<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import required from "vuelidate/lib/validators/required";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import DatePicker from "vue2-datepicker";
import Contract from "@/components/modals/contract-history.vue";
import IAR from "@/components/modals/iar-delivery.vue";
import Warehouse from "@/components/modals/property-warehouse.vue";
import Campus from "@/components/modals/campus.vue";
import Unit from "@/components/modals/unit.vue";
import PoSearch from "@/components/modals/purchase-order-search.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import RawData from "@/components/widgets/raw-data.vue";
import { orderBy } from "lodash";

export default {
  page: {
    title: "Incoming Deliveries"
  },
  components: {
    Layout,
    PageHeader,
    MaskedInput,
    DatePicker,
    Contract,
    IAR,
    Warehouse,
    Campus,
    Unit,
    PoSearch,
    UploadPopover,
    PrintOptions,
    RawData
  },
  data() {
    return {
      title: "Incoming Deliveries",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Incoming Deliveries",
          active: true
        }
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      modalTitle: "",
      po: {
        id: null,
        description: ""
      },
      tableData: [],
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      loading: false,
      campusId: this.$store.state.data.selectedCampus.id,
      cycle: this.$store.state.data.cycle,
      form: {
        poNumber: "",
        supplier: "",
        poId: null,
        dateOfDelivery: "",
        dateInspected: "",
        acceptanceDate: "",
        drNumber: "",
        cycle: "",
        supplySignatoryId: "",
        supplySignatoryPosition: "",
        inspectionHeadId: "",
        sendEmail: true,
        formItems: [],
        iarItems: []
      },
      formTransfer: {
        poId: null,
        campusId: null,
        campusName: "",
      },
      formEdit: {
        rfqSupplierId: null,
        rfqItemId: null,
        itemName: "",
        description: "",
        brand: "",
        model: "",
        specification: "",
        color: "",
        dimensionDescription: "",
        materialUsed: "",
        packageDescription: "",
        condition: "",
        unitId: "",
        unitName: "",
        quantity: "",
        unitCost: "",
        deliveryPeriod: "",
        note: ""
      },
      poIndex: -1,
      itemIndex: -1, tabIndex: 0,
      statusSelect: "Ongoing",
      statusOptions: [
        "Ongoing",
        "To Expire",
        "Expired",
        "With Pending Extension",
        "With Extension",
        "With Pending Suspension",
        "With Suspension",
        "All"
      ],
      addDocu: false,
      attachmentLoading: false,
      poFiles: [],
      viewFile: false,
      cycleOptions: [],
      mouseOverSearch: false,
      viewOnly: false,
      isAdmin: this.$store.state.decrypt.isAdmin(),
      token: this.$store.state.decrypt.getToken(),
      uploadOptions: {
        type: "Purchase Order",
        placement: "lefttop",
        folder: "Property"
      }
    };
  },
  validations: {
    form: {
      dateOfDelivery: { required },
      acceptanceDate: { required },
      drNumber: { required },
      cycle: { required }
    }
  },
  computed: {
    filtered() {
      // Optimize filtering by checking status first
      let isExtensionStatus = ["With Pending Extension", "With Extension",
        "With Pending Suspension", "With Suspension"].includes(this.statusSelect);

      // For extension statuses, preload extensions data in batches
      if (isExtensionStatus && this.tableData.length > 0) {
        // Only preload extension data for visible items (within current page range)
        const startIdx = (this.currentPage - 1) * this.perPage;
        const endIdx = Math.min(startIdx + this.perPage + 5, this.tableData.length); // Load a few extra for scrolling
        for (let i = startIdx; i < endIdx; i++) {
          if (i >= 0 && i < this.tableData.length && !this.tableData[i].extensionsLoaded) {
            this.loadContractExtensions(this.tableData[i]);
          }
        }
      }

      let data = this.tableData;
      if (this.statusSelect != "") {
        data = data.filter((item) => {
          if (this.statusSelect == "Ongoing")
            return (
              this.checkDeliveryDate(
                new Date(item.expectedDelivery),
                item.numberOfDays
              ) == "ongoing"
            );
          else if (this.statusSelect == "To Expire")
            return (
              this.checkDeliveryDate(
                new Date(item.expectedDelivery),
                item.numberOfDays
              ) == "warning"
            );
          else if (this.statusSelect == "Expired")
            return (
              this.checkDeliveryDate(
                new Date(item.expectedDelivery),
                item.numberOfDays
              ) == "expired"
            );
          else if (this.statusSelect == "With Pending Extension")
            return this.hasExtensionWithStatus(item, "EXTENSION", "PENDING");
          else if (this.statusSelect == "With Extension")
            return this.hasExtensionWithStatus(item, "EXTENSION", "APPROVED");
          else if (this.statusSelect == "With Pending Suspension")
            return this.hasExtensionWithStatus(item, "SUSPENSION", "PENDING");
          else if (this.statusSelect == "With Suspension")
            return this.hasExtensionWithStatus(item, "SUSPENSION", "APPROVED");
          else return item;
        });
      }
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.description.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.description
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (
            item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.poNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (
            item.supplierName.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.supplierName
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (
            item.endUser.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.endUser
              .toUpperCase()
              .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    }
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
    if (this.$store.state.decrypt.isAdmin()) {
      this.viewOnly = false;
    } else {
      let accessList = this.$store.state.decrypt.userAccessList();
      let access = accessList.find(
        (x) =>
          x.Access.toLowerCase() === "manage incoming delivery" &&
          x.Type.toLowerCase() === "inspection"
      );
      if (access) {
        this.viewOnly = false;
      } else {
        this.viewOnly = true;
      }
    }
  },
  methods: {
    changeCampus(campus) {
      this.cycle = this.$store.state.data.cycle;
      this.campusId = campus.id;
      if (this.tabIndex != 8) {
        this.getPending();
      } else {
        this.getCompleted();
      }
    },
    changeDU(du) {
      this.cycle = this.$store.state.data.cycle;
      this.campusId = du.campusId;
      if (this.tabIndex != 8) {
        this.getPending();
      } else {
        this.getCompleted();
      }
    },
    changeCycle(cycle) {
      this.cycle = cycle;
      this.campusId = this.$store.state.data.selectedCampus.id;
      if (this.tabIndex != 8) {
        this.getPending();
      } else {
        this.getCompleted();
      }
    },
    getPending() {
      this.loading = true;
      var cycle = this.cycle;
      var campusId = this.campusId;
      this.$store
        .dispatch("inspectioncontract/GetInspectionContractPending", {
          cycle,
          campusId
        })
        .then((res) => {
          this.loading = false;
          res.data.forEach((x) => {
            x.loading = false;
            x.visible = false;
            x.toggleAll = false;
            x.allSupplierOffer = true;
            x.allRequestedItem = false;
            x.rfqSupplierOffers = [];
            x.addDocu = false;
            x.attachmentLoading = false;
            x.poFiles = [];
            x.viewFile = false;
          });
          this.tableData = res.data.sort(function (a, b) {
            return b.expectedDelivery.localeCompare(a.expectedDelivery);
          });
        })
        .catch((err) => {
          this.showToast(
            "Something went wrong - Getting incoming deliveries!",
            "error"
          );
          this.loading = false;
        });
    },
    getCompleted() {
      this.loading = true;
      var cycle = this.cycle;
      var campusId = this.campusId;
      this.$store
        .dispatch("inspectioncontract/GetInspectionContractCompleted", {
          cycle,
          campusId
        })
        .then((res) => {
          this.loading = false;
          res.data.forEach((x) => {
            x.loading = false;
            x.visible = false;
            x.toggleAll = false;
            x.allSupplierOffer = true;
            x.allRequestedItem = false;
            x.rfqSupplierOffers = [];
            x.addDocu = false;
            x.attachmentLoading = false;
            x.poFiles = [];
            x.viewFile = false;
          });
          this.tableData = res.data;
        })
        .catch((err) => {
          this.showToast(
            "Something went wrong - Getting incoming deliveries!",
            "error"
          );
          this.loading = false;
        });
    },
    getRfqItems(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.loading = true;
        row.toggleAll = false;
        setTimeout(() => {
          this.$store
            .dispatch("inspectioncontract/GetInspectionContractItemsPending", row.rfqSupplierId)
            .then((res) => {
              res.data.forEach((y) => {
                y.supplierOffer = y.availableItemsForIar > 0 ? true : false;
                y.requestedItem = false;
                y.toggleSelected = false;
                y.empty = y.availableItemsForIar > 0 ? false : true;
                y.sortName = y.apiResourceItemName.replace(' - ', 'a').replace('-', '').replace('–', '').replace(':', '1').replace(/\s+/g,'').replace(/'/g, '').trim().toLowerCase()
                y.sortDescription = y.apiResourceDescription.replace(' - ', 'a').replace('-', '').replace('–', '').replace(':', '1').replace(/'/g, '').replace(/\s+/g,'').replace(/[\r\n]/gm, '').trim().toLowerCase();
              });
              row.rfqSupplierOffers = orderBy(res.data, ['sortName', 'sortDescription'], ['asc', 'asc']);
              row.loading = false;
            });
        }, 1000);
      }
    },
    getIarItems(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.loading = true;
        row.toggleAll = false;
        setTimeout(() => {
          this.$store
            .dispatch(
              "inspectioncontract/GetInspectionContractItemsCompleted",
              row.id
            )
            .then((res) => {
              row.rfqSupplierOffers = res.data.sort((a, b) =>
                a.itemName.localeCompare(b.itemName)
              );
              row.loading = false;
            });
        }, 1000);
      }
    },

    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (
        (this.$v.$invalid && this.checkIfWaived()) ||
        this.checkCreateForm()
      ) {
        return;
      } else {
        this.$swal({
          title: "Select an Action",
          text:
            "Do you want to send an Email to COA confirming delivery arrival?",
          icon: "question",
          showCancelButton: true,
          showDenyButton: true,
          cancelButtonColor: "#5c636a",
          denyButtonColor: "#34c38f",
          denyButtonText: "Confirm & Email",
          confirmButtonColor: "#349ac3",
          confirmButtonText: "Just Confirm",
          customClass: {
            actions: "my-actions",
            denyButton: "order-1",
            confirmButton: "order-2",
            cancelButton: "order-3 left-gap"
          },
          allowOutsideClick: false
        }).then((result) => {
          if (result.isDismissed) {
            return;
          } else {
            if (result.isConfirmed) {
              this.form.sendEmail = false;
            } else if (result.isDenied) {
              this.form.sendEmail = true;
            }
            this.form.createAndPost = false;
            this.form.formItems.forEach((item) => {
              this.setIarItems(item);
            });
            this.form.dateInspected = "0001-01-01T00:00:00";
            this.form.dateOfDelivery = this.getDate(this.form.dateOfDelivery);
            if (this.checkIfWaived()) {
              this.form.acceptanceDate = this.getDate(this.form.acceptanceDate);
            } else {
              this.form.acceptanceDate = "0001-01-01T00:00:00";
              this.form.drNumber = "";
            }
            this.$store
              .dispatch("inspectioniar/CreateInspectionIar", this.form)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                var poIndex = this.tableData.findIndex(
                  (item) => item.id == this.form.poId
                );
                this.tableData[poIndex].toggleAll = false;
                var count = 0;
                this.form.iarItems.forEach((x) => {
                  var itemIndex = this.tableData[
                    poIndex
                  ].rfqSupplierOffers.findIndex(
                    (item) => item.id == x.rfqSupplierOfferId
                  );
                  this.tableData[poIndex].rfqSupplierOffers[
                    itemIndex
                  ].toggleSelected = false;
                  this.tableData[poIndex].rfqSupplierOffers[
                    itemIndex
                  ].availableItemsForIar =
                    parseFloat(
                      this.tableData[poIndex].rfqSupplierOffers[itemIndex]
                        .availableItemsForIar
                    ) - parseFloat(x.quantity);
                  if (
                    this.tableData[poIndex].rfqSupplierOffers[itemIndex]
                      .availableItemsForIar == 0
                  ) {
                    count++;
                  }
                });
                if (this.tableData[poIndex].rfqSupplierOffers.length == count) {
                  this.tableData.splice(poIndex, 1);
                }
                this.showToast("Successfully confirmed!", "success");
                this.onReset();
                this.$bvModal.hide("modal-create");
              })
              .catch((err) => {
                this.showToast(
                  "Something went wrong - setting delivery!",
                  "error"
                );
              });
            this.submitted = false;
          }
        });
      }
    }, 
    createIar(props) {
      // Check for both pending extensions and suspensions
      if (this.hasExtensionWithStatus(props, 'EXTENSION', 'PENDING') ||
        this.hasExtensionWithStatus(props, 'SUSPENSION', 'PENDING')) {
        this.showToast(
          "Pending contract extension/suspension is still awaiting approval.",
          "warning"
        );
      } else {
        this.onReset();
        this.form.poNumber = props.poNumber;
        this.form.supplier = props.supplierName;
        this.form.poId = props.id;
        this.form.dateOfDelivery = new Date();
        this.form.acceptanceDate = new Date();
        this.form.createAndPost = false;
        this.poIndex = this.tableData.indexOf(props);
        this.form.cycle = this.cycle;
        this.form.toggleAllOffer = true;
        this.form.toggleAllRequest = false;
        this.form.toggleAllWarehouse = false;
        props.rfqSupplierOffers.forEach((item) => {
          if (item.toggleSelected === true) {
            this.form.formItems.push({
              toggleOffer: true,
              toggleRequest: false,
              iarId: 0,
              rfqSupplierOfferId: item.id,
              offerName: item.itemName,
              offerDescription: item.description,
              requestName: item.apiResourceItemName,
              requestDescription: item.apiResourceDescription,
              itemName: "",
              description: "",
              brand: item.brand,
              model: item.model,
              specification: item.specification,
              color: item.color,
              dimensionDescription: item.dimensionDescription,
              materialUsed: item.materialUsed,
              packageDescription: item.packageDescription,
              condition: "New",
              itemCategoryId: item.itemCategoryId,
              itemCategoryName: item.itemCategory,
              warrantyStartDate: "",
              warrantyEndDate: "",
              unitId: item.unitId,
              unitName: item.unit ? item.unit.unitName : "",
              notes: "",
              quantity: 0,
              qtyDelivered: item.availableItemsForIar.toString(),
              qtyWaived: 0,
              qtyPending: 0,
              max: item.availableItemsForIar.toString(),
              unitCost: item.unitCost.toString(),
              isDelivered: false,
              locationAreaId: 0,
              locationAreaName: ""
            });
          }
        });
        this.modalTitle = "Delivery";
        this.$bvModal.show("modal-create");
      }
    },
    onTransferCampus() {
      this.submitted = true;
      if (this.formTransfer.campusId == null || this.formTransfer.campusId == '') return;
      this.$store
        .dispatch("po/MoveToCampus", { id: this.formTransfer.poId, campusId: this.formTransfer.campusId })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.tableData.splice(this.tableData.findIndex(x => x.id == this.formTransfer.poId), 1);
          this.showToast("Successfully transfered!", "success");
          this.$bvModal.hide('modal-transfer-campus');
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    transferCampus(props) {
      this.onReset();
      this.formTransfer.poId = props.id;
      this.modalTitle = `${this.GLOBAL_FROM_SCHOOL ? 'Transfer Campus' : 'Transfer Main Office'}`;
      this.$bvModal.show("modal-transfer-campus");
    },
    onUpdatePoItem() {
      this.submitted = true;
      if (
        this.formEdit.itemName == "" ||
        this.formEdit.description == "" ||
        this.formEdit.unitCost == "" ||
        this.formEdit.unitId == null ||
        this.formEdit.condition == ""
      ) return;
      this.$swal({
        title: "Are you sure?",
        text: "You are about to update this item!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, update item!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.formEdit.unitCost = this.getExactAmt(this.formEdit.unitCost);
          this.$store
            .dispatch("rfqsupplieroffer/UpdateRSO", this.formEdit)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.tableData[this.poIndex].visible = false;
              this.getRfqItems(this.tableData[this.poIndex]);
              this.showToast("Successfully updated!", "success");
              this.$bvModal.hide('modal-update-item');
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
      this.submitted = false;
    },
    updatePoItem(poData, itemData) {
      this.onReset();
      this.poIndex = this.tableData.indexOf(poData);
      this.$store
        .dispatch(
          "rfqsupplieroffer/GetSingleRSO",
          itemData.id
        )
        .then((res) => {
          this.formEdit = res.data;
          this.formEdit.unitCost = res.data.unitCost.toString();
          this.formEdit.unitName = itemData.unit;
          if (res.data.condition == "") {
            this.formEdit.condition = "New";
          }
        });
      this.modalTitle = "Update Item";
      this.$bvModal.show("modal-update-item");
    },
    checkCreateForm(item) {
      var count = 0;
      this.form.formItems.forEach((item) => {
        if (
          (!item.toggleOffer && !item.toggleRequest) ||
          this.checkQtyEmpty(item.max, item.qtyPending)
        )
          count++;
        // if (item.qtyDelivered > 0 && item.locationAreaId == null) count++;
      });
      if (count > 0) return true;
    },
    setIarItems(item) {
      if (parseFloat(item.qtyDelivered) > 0) {
        this.form.iarItems.push({
          itemName: `${item.toggleRequest ? `${item.requestName}` : ""}${item.toggleRequest && item.toggleOffer ? ", " : " "
            }${item.toggleOffer ? `${item.offerName}` : ""}`,
          description: `${item.toggleRequest ? `${item.requestDescription}` : ""
            }${item.toggleRequest && item.toggleOffer ? ", " : " "}${item.toggleOffer ? `${item.offerDescription}` : ""
            }`,
          iarId: item.iarId,
          rfqSupplierOfferId: item.rfqSupplierOfferId,
          brand: item.brand,
          model: item.model,
          specification: item.specification,
          color: item.color,
          dimensionDescription: item.dimensionDescription,
          materialUsed: item.materialUsed,
          packageDescription: item.packageDescription,
          condition: item.condition,
          unitId: item.unitId,
          unitName: item.unitName,
          itemCategoryId: item.itemCategoryId,
          itemCategoryName: item.itemCategoryName,
          unitCost: this.getExactAmt(item.unitCost),
          warrantyStartDate: "0001-01-01T00:00:00",
          warrantyEndDate: "0001-01-01T00:00:00",
          notes: item.notes,
          quantity: item.qtyDelivered,
          isDelivered: true,
          locationAreaId: item.locationAreaId,
          locationAreaName: item.locationAreaName
        });
      }
      if (parseFloat(item.qtyWaived) > 0) {
        this.form.iarItems.push({
          itemName: `${item.toggleRequest ? `${item.requestName}` : ""}${item.toggleRequest && item.toggleOffer ? ", " : " "
            }${item.toggleOffer ? `${item.offerName}` : ""}`,
          description: `${item.toggleRequest ? `${item.requestDescription}` : ""
            }${item.toggleRequest && item.toggleOffer ? ", " : " "}${item.toggleOffer ? `${item.offerDescription}` : ""
            }`,
          iarId: item.iarId,
          rfqSupplierOfferId: item.rfqSupplierOfferId,
          brand: item.brand,
          model: item.model,
          specification: item.specification,
          color: item.color,
          dimensionDescription: item.dimensionDescription,
          materialUsed: item.materialUsed,
          packageDescription: item.packageDescription,
          condition: item.condition,
          unitId: item.unitId,
          unitName: item.unitName,
          itemCategoryId: item.itemCategoryId,
          itemCategoryName: item.itemCategoryName,
          unitCost: this.getExactAmt(item.unitCost),
          warrantyStartDate: "0001-01-01T00:00:00",
          warrantyEndDate: "0001-01-01T00:00:00",
          notes: item.notes,
          quantity: item.qtyWaived,
          isDelivered: false
        });
      }
    },
    toggleAll(row) {
      row.rfqSupplierOffers.forEach((item) => {
        if (!item.empty) item.toggleSelected = row.toggleAll;
      });
    },
    checkToggle(row) {
      var count = 0;
      row.rfqSupplierOffers.forEach((item) => {
        if (item.toggleSelected || item.empty) count++;
      });
      if (count === row.rfqSupplierOffers.length) {
        row.toggleAll = true;
      } else {
        row.toggleAll = false;
      }
    },
    selectedRowCheck(items) {
      var count = 0;
      items.forEach((item) => {
        item.toggleSelected && count++;
      });
      if (count > 0) return true;
      else return false;
    },
    toggleAllIarName() {
      this.form.formItems.forEach((item) => {
        item.toggleOffer = this.form.toggleAllOffer;
        item.toggleRequest = this.form.toggleAllRequest;
      });
    },
    checkIarName() {
      var countOffer = 0;
      var countRequested = 0;
      this.form.formItems.forEach((item) => {
        if (item.toggleOffer) countOffer++;
        if (item.toggleRequest) countRequested++;
      });
      if (countOffer === this.form.formItems.length) {
        this.form.toggleAllOffer = true;
      } else {
        this.form.toggleAllOffer = false;
      }
      if (countRequested === this.form.formItems.length) {
        this.form.toggleAllRequest = true;
      } else {
        this.form.toggleAllRequest = false;
      }
    },
    toggleAllWarehouseLocation() {
      if (this.form.toggleAllWarehouse) {
        this.form.formItems.forEach((item) => {
          item.locationAreaId = this.form.formItems[0].locationAreaId;
          item.locationAreaName = this.form.formItems[0].locationAreaName;
        });
      }
    },
    onReset() {
      this.form = {
        poId: null,
        dateOfDelivery: "",
        dateInspected: "",
        acceptanceDate: "",
        drNumber: "",
        cycle: "",
        supplySignatoryId: "",
        supplySignatoryPosition: "",
        inspectionHeadId: "",
        formItems: [],
        iarItems: []
      };
      this.formTransfer = {
        poId: null,
        campusId: null,
        campusName: "",
      };
      this.formEdit = {
        rfqSupplierId: null,
        rfqItemId: null,
        itemName: "",
        description: "",
        brand: "",
        model: "",
        specification: "",
        color: "",
        dimensionDescription: "",
        materialUsed: "",
        packageDescription: "",
        condition: "",
        unitId: "",
        unitName: "",
        quantity: "",
        unitCost: "",
        deliveryPeriod: "",
        note: ""
      },
        this.addDocu = false;
      this.attachmentLoading = false;
      this.poFiles = [];
      this.viewFile = false;
      this.submitted = false;
      this.getCycleOptions();
    },
    getCampus() {
      this.$refs.campus.getData();
      this.$bvModal.show("campus-modal");
    },
    dropCampus(data) {
      this.formTransfer.campusId = data.id;
      this.formTransfer.campusName = data.campusName;
    },
    getWarehouse(props) {
      this.itemIndex = this.form.formItems.indexOf(props);
      this.$refs.warehouse.getData(this.campusId);
      this.$bvModal.show("warehouse-modal");
    },
    dropWarehouse(data) {
      if (this.form.toggleAllWarehouse) {
        this.form.formItems.forEach((item) => {
          item.locationAreaId = data.id;
          item.locationAreaName = data.areaName;
        });
        this.$forceUpdate();
      } else {
        this.form.formItems[this.itemIndex].locationAreaId = data.id;
        this.form.formItems[this.itemIndex].locationAreaName = data.areaName;
        this.$forceUpdate();
      }
    },
    removeWarehouse(props) {
      if (this.form.toggleAllWarehouse) {
        this.form.formItems.forEach((item) => {
          item.locationAreaId = 0;
          item.locationAreaName = "";
        });
        this.$forceUpdate();
      } else {
        this.itemIndex = this.form.formItems.indexOf(props);
        this.form.formItems[this.itemIndex].locationAreaId = 0;
        this.form.formItems[this.itemIndex].locationAreaName = "";
        this.$forceUpdate();
      }
    },
    getUnit() {
      this.$refs.unit.getData();
      this.$bvModal.show("unit-modal");
    },
    dropUnit(data) {
      this.formEdit.unitName = data.unitName;
      this.formEdit.unitId = data.id;
    },

    // New method to load contract extensions efficiently
    loadContractExtensions(item) {
      if (!item.extensionsLoaded) {
        item.extensionsLoaded = true;
        item.extensionsLoading = true;
        this.$store
          .dispatch("inspectionextension/GetDeliveryExtensionByPo", item.id)
          .then((res) => {
            if(res.data.error){
              return this.showToast(res.data.errorMessage, "error");
            }
            item.poDeliveryExtensions = res.data || [];
            item.extensionsLoading = false;
          })
          .catch(() => {
            item.poDeliveryExtensions = [];
            item.extensionsLoading = false;
          });
      }
    },

    // Helper method to check if a PO has extensions with specific type and status
    hasExtensionWithStatus(item, type, status) {
      // First ensure we have extensions data loaded
      // if (!item.poDeliveryExtensions) {
      //   this.loadContractExtensions(item);

      //   // For backward compatibility, use the withPendingExtension property
      //   // but only for EXTENSION+PENDING combination
      //   return (type === "EXTENSION" && status === "PENDING") ? item.withPendingExtension : false;
      // }
      item.poDeliveryExtensions = item.poDeliveryExtensions || [];
      // Look through the poDeliveryExtensions to find the specified type and status
      return item.poDeliveryExtensions.some(ext =>
        ext.type === type && ext.status === status
      );
    },

    getSuspension(row, type) {
      // Make sure we're passing a row with loaded extension data
      if (!row.extensionsLoaded) {
        this.loadContractExtensions(row);
      }
      this.$refs.contract.getSuspension(row, type);
      this.$bvModal.show("modal-contract");
    },
    getIar(row) {
      this.$refs.iar.getData(row.iarId);
      this.$bvModal.show("iar-modal");
    },
    checkQtyDelivered(row, type) {
      if (type == "delivered") {
        if (
          parseFloat(row.qtyDelivered) >
          parseFloat(row.max) - parseFloat(row.qtyWaived)
        ) {
          row.qtyDelivered = row.qtyPending;
        } else if (row.qtyDelivered == "" || parseFloat(row.qtyDelivered) < 0) {
          row.qtyDelivered = 0;
        }
      } else if (type == "waived") {
        if (
          parseFloat(row.qtyWaived) >
          parseFloat(row.max) - parseFloat(row.qtyDelivered)
        ) {
          row.qtyWaived = row.qtyPending;
        } else if (row.qtyWaived == "" || parseFloat(row.qtyWaived) < 0) {
          row.qtyWaived = 0;
        }
      }
      var decimalPending = row.qtyDelivered.toString().includes(".")
        ? row.qtyDelivered.length - row.qtyDelivered.indexOf(".") - 1
        : 0;
      var decimalWaived = row.qtyWaived.toString().includes(".")
        ? row.qtyWaived.length - row.qtyWaived.indexOf(".") - 1
        : 0;
      var decimal =
        decimalPending > decimalWaived ? decimalPending : decimalWaived;
      row.qtyPending = parseFloat(
        parseFloat(row.max) -
        ((row.qtyDelivered != "" ? parseFloat(row.qtyDelivered) : 0) +
          (row.qtyWaived != "" ? parseFloat(row.qtyWaived) : 0))
      ).toFixed(decimal);
    },

    checkQtyEmpty(qty, pending) {
      if (qty != null && pending != null) {
        if (parseFloat(qty) == parseFloat(pending)) return true;
        else return false;
      }
    },
    checkMax(qty, max) {
      if (qty != null && max != null) {
        if (parseFloat(qty) < 0 || parseFloat(qty) > parseFloat(max))
          return true;
        else return false;
      }
    },
    checkIfWaived() {
      var count = 0;
      this.form.formItems.forEach((item) => {
        if (item.qtyDelivered == 0 && item.qtyWaived > 0) count++;
      });
      if (count < this.form.formItems.length) return true;
    },
    checkDeliveryDate(deliveryDate, days) {
      var warningDays = days < 4 ? 1 : ~~(days / 4);
      var today = new Date();
      var nextweek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + warningDays
      );
      if (deliveryDate <= today) return "expired";
      else if (deliveryDate < nextweek) return "warning";
      else return "ongoing";
    },
    uploadDocument(response, id) {
      var index = this.tableData.findIndex((x) => x.id == id);
      this.tableData[index].poFiles.push(response);
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    searchDocu(row) {
      let data = row.poFiles;
      if (row.fileSearch.trim() != "" && row.fileSearch) {
        data = data.filter((item) => {
          return item.description
            .toUpperCase()
            .includes(row.fileSearch.toUpperCase());
        });
      }
      return data;
    },
    uploadedFiles() { },
    async getAttachments(row) {
      row.viewFile = true;
      row.poFiles = [];
      row.attachmentLoading = true;
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: "Purchase Order"
        })
        .then((res) => {
          res.data.forEach((item) => {
            row.poFiles.push(item);
          });
        })
        .catch(() => {
          this.showToast("Something went wrong! - getting documents", "error");
        });
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.prId,
          type: "Purchase Request"
        })
        .then((res) => {
          res.data.forEach((item) => {
            row.poFiles.push(item);
          });
        })
        .catch(() => {
          this.showToast("Something went wrong! - getting documents", "error");
        });
      row.attachmentLoading = false;
    },
    removeFile(id, parentId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.tableData.findIndex(
                (item) => item.id == parentId
              );
              let yIndex = this.tableData[index].poFiles.findIndex(
                (item) => item.id == id
              );
              this.tableData[index].poFiles.splice(yIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    searchPo() {
      this.$refs.PoSearch.resetData();
      this.$bvModal.show("po-search-modal");
    },
    getCycleOptions() {
      var cycles = [{ text: "", value: 0 }];
      this.$store.dispatch("cycle/GetAllCycle").then((res) => {
        res.data.forEach((item) => {
          cycles.push({ value: item.year, text: item.year });
        });
        this.cycleOptions = cycles;
      });
    },
    printDP(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/Procurement/Deployment",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },

    // Return appropriate icon class for each tab status
    getTabIcon(status) {
      switch (status) {
        case 'Ongoing':
          return 'mdi mdi-clock-outline text-success';
        case 'To Expire':
          return 'mdi mdi-clock-alert-outline text-warning';
        case 'Expired':
          return 'mdi mdi-clock-remove-outline text-danger';
        case 'With Pending Extension':
          return 'mdi mdi-calendar-clock text-info';
        case 'With Extension':
          return 'mdi mdi-calendar-check text-success';
        case 'With Pending Suspension':
          return 'mdi mdi-calendar-remove text-warning';
        case 'With Suspension':
          return 'mdi mdi-calendar-remove-outline text-danger';
        case 'All':
          return 'mdi mdi-view-grid-outline';
        default:
          return 'mdi mdi-check-circle-outline text-success';
      }
    },

    getCurrentCategory() {
      localStorage.setItem("currentCategory", this.filter);
      this.$router.push("/property/category");
    },

    // Load extension data in batches for visible items
    loadVisibleExtensionData() {
      const isExtensionStatus = ["With Pending Extension", "With Extension",
        "With Pending Suspension", "With Suspension"].includes(this.statusSelect);

      if (isExtensionStatus && this.tableData.length > 0) {
        // Process items in small batches to avoid freezing the UI
        const batchSize = 5;
        const startIdx = (this.currentPage - 1) * this.perPage;
        const endIdx = Math.min(startIdx + this.perPage, this.tableData.length);

        // Create a function to process items in batches
        const processBatch = (start) => {
          const end = Math.min(start + batchSize, endIdx);

          for (let i = start; i < end; i++) {
            if (i >= 0 && i < this.tableData.length && !this.tableData[i].extensionsLoaded) {
              this.loadContractExtensions(this.tableData[i]);
            }
          }

          // Process the next batch if needed
          if (end < endIdx) {
            setTimeout(() => {
              processBatch(end);
            }, 100);
          }
        };

        // Start processing batches
        processBatch(startIdx);
      }
    },
    getDataByStatus(status){
      if(status == 'completed'){
        this.statusSelect = '';
        this.getCompleted();
      } else{
        this.statusSelect = status;
        this.getPending();
      }
      this.filter = '';
      this.perPage = 10;
      this.currentPage = 1;
    }
  }
};
</script>
<template>
  <Layout @changeCampus="changeCampus" @changeDU="changeDU" @changeCycle="changeCycle">
    <PageHeader :title="title" :items="items" />
    <!-- Create IAR -->
    <b-modal id="modal-create" :title="modalTitle" size="xxl" title-class="font-18" hide-footer no-close-on-backdrop>
      <div class="mb-3">
        <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
          <h5 class="mb-0">{{ form.poNumber }}</h5>
          <div class="mb-3">
            {{ form.supplier }}
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="dateOfDelivery">Date of Delivery</label>
              <date-picker v-model="form.dateOfDelivery" lang="en" placeholder="Enter Date of Delivery..." :class="{
                'is-invalid': submitted && $v.form.dateOfDelivery.$error
              }"></date-picker>
              <div v-if="submitted && $v.form.dateOfDelivery.$error" class="invalid-feedback">
                <span v-if="!$v.form.dateOfDelivery.required">This value is required.</span>
              </div>
            </div>
            <div class="col-md-6">
              <label for="cycle">Cycle</label>
              <b-form-select id="cycle" v-model="form.cycle" :options="cycleOptions" class="form-select" :class="{
                'is-invalid': submitted && $v.form.cycle.$error
              }"></b-form-select>
              <div v-if="submitted && $v.form.cycle.$error" class="invalid-feedback">
                <span v-if="!$v.form.cycle.required">This value is required.</span>
              </div>
            </div>
          </div>
          <b-collapse :visible="checkIfWaived()">
            <div v-if="checkIfWaived()">
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="acceptanceDate">Acceptance Date</label>
                  <date-picker v-model="form.acceptanceDate" lang="en" placeholder="Enter Date of Delivery..." :class="{
                    'is-invalid': submitted && $v.form.acceptanceDate.$error
                  }"></date-picker>
                  <div v-if="submitted && $v.form.acceptanceDate.$error" class="invalid-feedback">
                    <span v-if="!$v.form.acceptanceDate.required">This value is required.</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="drNumber">Invoice Number / D.R. Number</label>
                  <input id="drNumber" type="text" v-model="form.drNumber" placeholder="Enter Invoice/D.R. Number..."
                    class="form-control" :class="{
                      'is-invalid': submitted && $v.form.drNumber.$error
                    }" autocomplete="off" />
                  <div v-if="submitted && $v.form.drNumber.$error" class="invalid-feedback">
                    <span v-if="!$v.form.drNumber.required">This value is required.</span>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
          <div class="mb-2">
            <h5 class="text-muted">
              Delivery Items: {{ form.formItems.length }}
            </h5>
            <div style="max-height: 530px; overflow: auto">
              <table width="100%">
                <thead>
                  <tr class="border-bottom">
                    <th class="py-2" style="min-width: 150px">
                      <div class="form-check form-checkbox-outline form-check-success">
                        <input type="checkbox" id="allOfferCheckbox" checked="checked"
                          class="form-check-input hide-disable" @change="toggleAllIarName()"
                          v-model="form.toggleAllOffer" :disabled="!form.toggleAllRequest ? true : false" /><label
                          for="allOfferCheckbox" class="form-check-label hide-disable">
                          <b>Supplier Offer</b>
                        </label>
                      </div>
                    </th>
                    <th class="py-2" style="min-width: 150px">
                      <div class="form-check form-checkbox-outline form-check-success">
                        <input type="checkbox" id="allRequestedCheckbox" checked="checked"
                          class="form-check-input hide-disable" @change="toggleAllIarName()"
                          v-model="form.toggleAllRequest" :disabled="!form.toggleAllOffer ? true : false" /><label
                          for="allRequestedCheckbox" class="form-check-label hide-disable">
                          <b>Requested Item</b>
                        </label>
                      </div>
                    </th>
                    <th class="py-2" style="min-width: 150px">Selected Name</th>
                    <th class="py-2" style="width: 400px">
                      <div class="form-check form-checkbox-outline form-check-success">
                        <input type="checkbox" id="AllWarehouseCheckbox" checked="checked"
                          class="form-check-input hide-disable" @change="toggleAllWarehouseLocation()"
                          v-model="form.toggleAllWarehouse" /><label for="AllWarehouseCheckbox"
                          class="form-check-label hide-disable">
                          <b>Warehouse Location</b>
                        </label>
                      </div>
                    </th>
                    <th class="py-2" style="width: 100px">Delivered</th>
                    <th class="py-2" style="width: 100px">Waived</th>
                    <th class="py-2" style="width: 100px">Pending</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="y in form.formItems" :key="y.rfqSupplierOfferId" class="border-bottom">
                    <td class="py-2 align-top">
                      <div class="form-check form-checkbox-outline form-check-success">
                        <input type="checkbox" :id="`offerCheckbox-${y.rfqSupplierOfferId}`" checked="checked"
                          class="form-check-input" :class="{
                            'hide-disable': !y.toggleRequest
                          }" @change="checkIarName()" v-model="y.toggleOffer"
                          :disabled="!y.toggleRequest ? true : false" /><label
                          :for="`offerCheckbox-${y.rfqSupplierOfferId}`" class="form-check-label" :class="{
                            'hide-disable': !y.toggleRequest
                          }">
                          <div>
                            {{ y.offerName }}
                          </div>
                          <small>{{ y.offerDescription }}</small>
                        </label>
                      </div>
                    </td>
                    <td class="py-2 align-top">
                      <div class="form-check form-checkbox-outline form-check-success">
                        <input type="checkbox" :id="`requestedCheckbox-${y.rfqSupplierOfferId}`" checked="checked"
                          class="form-check-input" :class="{
                            'hide-disable': !y.toggleOffer
                          }" @change="checkIarName()" v-model="y.toggleRequest"
                          :disabled="!y.toggleOffer ? true : false" /><label
                          :for="`requestedCheckbox-${y.rfqSupplierOfferId}`" class="form-check-label" :class="{
                            'hide-disable': !y.toggleOffer
                          }">
                          <div>
                            {{ y.requestName }}
                          </div>
                          <small>{{ y.requestDescription }}</small>
                        </label>
                      </div>
                    </td>
                    <td class="py-2 align-top">
                      <div>
                        {{
                          `${y.toggleRequest ? `${y.requestName}` : ""}${y.toggleRequest && y.toggleOffer ? ", " : " "
                          }${y.toggleOffer ? `${y.offerName}` : ""}`
                        }}
                      </div>
                      <small>{{
                        `${y.toggleRequest ? `${y.requestDescription}` : ""}${y.toggleRequest && y.toggleOffer ? ", " :
                          " "
                        }${y.toggleOffer ? `${y.offerDescription}` : ""}`
                      }}</small>
                    </td>
                    <td class="py-2 align-top pe-2">
                      <b-input-group>
                        <template #append>
                          <b-button v-if="y.locationAreaId > 0" @click="removeWarehouse(y)" variant="outline-danger"><i
                              class="mdi mdi-close"></i></b-button>
                          <b-button v-else @click="getWarehouse(y)" variant="outline-info"><i
                              class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                        </template>
                        <input autocomplete="off" type="text" disabled placeholder="Search Warehouse Location..."
                          class="form-control" :class="{
                            'is-invalid':
                              submitted &&
                              (y.locationAreaId === '' ||
                                y.locationAreaId === null)
                          }" v-model="y.locationAreaName" />
                      </b-input-group>
                      <div v-if="
                        submitted &&
                        (y.locationAreaId === '' ||
                          y.locationAreaId === null)
                      " class="invalid-feedback">
                        <span>This value is required.</span>
                      </div>
                    </td>
                    <td class="py-2 pe-2 align-top text-warning">
                      <input type="number" @change="checkQtyDelivered(y, 'delivered')" v-model="y.qtyDelivered"
                        step="any" :max="y.max" min="0" placeholder="Enter Delivered Items..." class="form-control"
                        :class="{
                          'is-invalid':
                            submitted &&
                            (checkQtyEmpty(y.max, y.qtyPending) ||
                              checkMax(y.qtyDelivered, y.max))
                        }" autocomplete="off" />
                      <div v-if="submitted && checkMax(y.quantity, y.max)" class="invalid-feedback">
                        <span>This value must be less than or equal to
                          {{ y.max }}.</span>
                      </div>
                    </td>
                    <td class="py-2 pe-2 align-top text-warning">
                      <input type="number" @input="checkQtyDelivered(y, 'waived')" v-model="y.qtyWaived" step="any"
                        :max="y.max" min="0" placeholder="Enter Waived Items..." class="form-control" :class="{
                          'is-invalid':
                            submitted &&
                            (checkQtyEmpty(y.max, y.qtyPending) ||
                              checkMax(y.qtyWaived, y.max))
                        }" autocomplete="off" />
                      <div v-if="submitted && checkMax(y.quantity, y.max)" class="invalid-feedback">
                        <span>This value must be less than or equal to
                          {{ y.max }}.</span>
                      </div>
                    </td>
                    <td class="py-2 pe-2 align-top text-warning">
                      <input id="qtyDelivered" type="number" v-model="y.qtyPending" step="any" disabled
                        class="form-control" autocomplete="off" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="d-flex flex-row-reverse mb-3">
            <button class="btn btn-primary mt-3" type="submit">Submit</button>
          </div>
        </form>
      </div>
    </b-modal>
    <!-- Transfer Campus -->
    <b-modal id="modal-transfer-campus" :title="modalTitle" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <label for="supplier">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
      <b-input-group>
        <template #append>
          <b-button @click="getCampus()" variant="outline-info" :title="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`"><i
              class="mdi mdi-clipboard-text-search-outline"></i></b-button>
        </template>
        <input autocomplete="off" type="text" :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" disabled class="form-control" :class="{
          'is-invalid': submitted && formTransfer.campusId == null || formTransfer.campusId == ''
        }" v-model="formTransfer.campusName" />
      </b-input-group>
      <div v-if="submitted && formTransfer.campusId == null || formTransfer.campusId == ''" class="invalid-feedback">
        <span>This value is required.</span>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary mt-3" type="button" id="inputGroupFileAddon04" @click="onTransferCampus">
          Transfer
        </button>
      </div>
    </b-modal>
    <!-- Edit Item -->
    <b-modal id="modal-update-item" :title="modalTitle" size="xl" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <div class="mb-3">
        <form @submit.prevent="onUpdatePoItem" class="needs-validation" ref="fcForm">
          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label for="itemName">Item Name </label>
                <input id="itemName" type="text" v-model="formEdit.itemName" placeholder="Enter Item Name..."
                  class="form-control" :class="{
                    'is-invalid': submitted && formEdit.itemName == ''
                  }" autocomplete="off" />
                <div v-if="submitted && formEdit.itemName == ''" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="unitCost">Unit Cost </label>
                <masked-input id="unitCost" type="text" v-model="formEdit.unitCost" placeholder="Enter Unit Cost..."
                  class="form-control" :class="{
                    'is-invalid': submitted && formEdit.unitCost == ''
                  }" autocomplete="off" :mask="currencyMask"></masked-input>
                <div v-if="submitted && formEdit.unitCost == ''" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="condition">Condition </label>
                <b-form-select class="form-select" :class="{
                  'is-invalid': submitted && formEdit.condition == ''
                }" v-model="formEdit.condition">
                  <b-form-select-option value="" disabled>Select Condition...</b-form-select-option>
                  <b-form-select-option value="New">New</b-form-select-option>
                  <b-form-select-option value="Purchased">Purchased</b-form-select-option>
                  <b-form-select-option value="Used">Used</b-form-select-option>
                  <b-form-select-option value="Donated">Donated</b-form-select-option>
                  <b-form-select-option value="Refurbished">Refurbished</b-form-select-option>
                  <b-form-select-option value="Re-condition">Re-condition</b-form-select-option>
                </b-form-select>
                <div v-if="submitted && formEdit.condition == ''" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="brand">Brand </label>
                <input id="brand" type="text" v-model="formEdit.brand" placeholder="Enter Brand..." class="form-control"
                  autocomplete="off" />
              </div>
              <div class="mb-3">
                <label for="dimensionDescription">Dimension Description
                </label>
                <textarea id="dimensionDescription" rows="3" v-model="formEdit.dimensionDescription"
                  placeholder="Enter Dimension Description..." class="form-control" autocomplete="off"></textarea>
              </div>
              <div class="mb-3">
                <label for="packageDescription">Package Description
                </label>
                <textarea id="packageDescription" rows="3" v-model="formEdit.packageDescription"
                  placeholder="Enter Package Description..." class="form-control" autocomplete="off"></textarea>
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <label for="description">Description </label>
                <input id="description" type="text" v-model="formEdit.description" placeholder="Enter Description..."
                  class="form-control" :class="{
                    'is-invalid': submitted && formEdit.description == ''
                  }" autocomplete="off" />
                <div v-if="submitted && formEdit.description == ''" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="unit">Unit </label>
                <b-input-group>
                  <template #append>
                    <b-button @click="getUnit()" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Search Unit..." class="form-control"
                    :class="{
                      'is-invalid': submitted && formEdit.unitId == null
                    }" v-model="formEdit.unitName" />
                </b-input-group>
                <div v-if="submitted && formEdit.unitId == null" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="brand">Model </label>
                <input id="model" type="text" v-model="formEdit.model" placeholder="Enter Model..." class="form-control"
                  autocomplete="off" />
              </div>
              <div class="mb-3">
                <label for="color">Color </label>
                <input id="color" type="text" v-model="formEdit.color" placeholder="Enter Property Color..."
                  class="form-control" autocomplete="off" />
              </div>
              <div class="mb-3">
                <label for="specification">Specification </label>
                <textarea id="specification" rows="3" v-model="formEdit.specification"
                  placeholder="Enter Specification..." class="form-control" autocomplete="off"></textarea>
              </div>
              <div class="mb-3">
                <label for="materialUsed">Material Used
                </label>
                <textarea id="materialUsed" rows="3" v-model="formEdit.materialUsed"
                  placeholder="Enter Material Used..." class="form-control" autocomplete="off"></textarea>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label for="note">Notes
            </label>
            <textarea id="note" rows="3" v-model="formEdit.materialUsed" placeholder="Enter Notes..."
              class="form-control" autocomplete="off"></textarea>
          </div>
          <div class="d-flex flex-row-reverse mb-3">
            <button class="btn btn-primary mt-3" type="submit">Update</button>
          </div>
        </form>
      </div>
    </b-modal> <!-- Main -->
    <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
      <b-tab v-for="(status, index) in statusOptions" :key="index" @click="getDataByStatus(status)"> <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i :class="getTabIcon(status)"></i>
          </span>
          <span class="d-none d-sm-inline-block">{{ status }}</span>
        </template>
        <div v-if="tabIndex == index">
          <div class="card border-4 border-top border-start-0 border-end-0 border-primary">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <h4 class="m-0 pt-3">P.O. List</h4>
                <div class="d-flex align-items-center">
                  <div id="tickets-table_filter" class="tableDatas_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search PO..."
                        class="form-control"></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="tableDatas_length">
                    <label class="d-inline-flex align-items-center">
                      <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptions">
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
              <div class="border p-3 d-flex align-items-center justify-content-center" v-if="loading">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
              <div class="text-center border p-3" v-else-if="paginated.length == 0">
                <div v-if="filter != ''">
                  <i class="fas fa-exclamation-triangle me-2"></i>There are no
                  POs matching your request
                </div>
                <div v-else>
                  <i class="fas fa-exclamation-triangle me-2"></i>No POs
                  available
                </div>
              </div>
              <div v-else class="border">
                <div class="text-muted" role="tablist" v-for="(x, index) in paginated" :key="x.id">
                  <b-card no-body class="mb-0 border shadow-none"
                    :style="`z-index: ${paginated.length - index + 1000}`">
                    <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                    <b-card-header header-tag="header" role="tab">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <div class="d-flex align-items-center" style="min-width: max-content">
                            <div class="text-white">PO# {{ x.poNumber }}</div>
                            <div class="ms-2">|</div>
                            <small class="ms-2">
                              {{ x.supplierName }}
                            </small>
                          </div>
                          <div class="text-white font-size-14 mb-1">
                            {{ x.description }}
                          </div>
                          <div class="d-flex align-items-center" style="min-width: max-content">
                            <div v-b-tooltip.bottomleft.hover="'Expected Date of Delivery'
                              " class="badge bg-soft" :class="checkDeliveryDate(
                                new Date(x.expectedDelivery),
                                x.numberOfDays
                              ) == 'ongoing'
                                ? 'bg-success'
                                : checkDeliveryDate(
                                  new Date(x.expectedDelivery),
                                  x.numberOfDays
                                ) == 'warning'
                                  ? 'bg-warning text-warning'
                                  : 'bg-danger text-danger'
                                ">
                              <b class="font-size-12"></b>
                              {{
                                formatDate(new Date(x.expectedDelivery))
                              }}
                            </div> <span v-if="!x.visible && (hasExtensionWithStatus(x, 'EXTENSION', 'PENDING') ||
                              hasExtensionWithStatus(x, 'SUSPENSION', 'PENDING'))"
                              class="badge bg-danger rounded-pill ms-1 position-relative">!</span>
                            <div class="ms-2">|</div>
                            <small class="ms-1">
                              <a href="javascript: void(0);" class="text-success d-flex align-items-center ms-1"
                                @click="getRfqItems(x)">
                                {{ x.visible ? "Hide" : "Show" }}
                                Details
                                <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                  'rotate-90': x.visible
                                }"></i>
                              </a>
                            </small>
                          </div>
                        </div>
                        <div v-if="!viewOnly" class="float-end d-flex align-items-center">
                          <i class="bx bx-printer font-size-18 text-purple cursor-pointer ps-2 pe-2 ms-2"
                            :id="`incoming-print-popover-${x.id}`" tabindex="0"></i>
                          <b-popover :target="`incoming-print-popover-${x.id}`" triggers="click blur"
                            placement="leftbottom" variant="purple" custom-class="p-0">
                            <b-list-group class="w-100 fit">
                              <b-list-group-item button action class="d-flex align-items-center text-purple"
                                @click="printDP(x.id)">Print Deployment</b-list-group-item>
                            </b-list-group>
                          </b-popover>
                          <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2" :id="`incoming-popover-${x.id}`"
                            tabindex="0"></i>
                          <b-popover :target="`incoming-popover-${x.id}`" triggers="click blur" placement="leftbottom"
                            variant="secondary" custom-class="p-0">
                            <b-list-group class="w-100 fit">
                              <b-list-group-item v-if="!x.visible" button action
                                class="d-flex align-items-center text-warning" @click="getSuspension(x, 'CREATE')"><i
                                  class="mdi mdi-calendar-clock font-size-18 me-1"></i>Show Contract
                                Management</b-list-group-item>
                              <b-list-group-item button action class="d-flex align-items-center text-info"
                                @click="transferCampus(x)"><i class="mdi mdi-transfer font-size-18 me-1"></i>Transfer
                                {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</b-list-group-item>
                            </b-list-group>
                          </b-popover>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse class="border-bottom border-5" :visible="x.visible" :accordion="`po-accordion-${x.id}`"
                      role="tabpanel">
                      <b-card-body
                        class="border border-3 border-bottom-0 border-start-0 border-end-0 custom-table-responsive">
                        <div class="d-flex">
                          <div class="me-3" style="min-width: 250px">
                            <div v-if="!viewOnly"> <button type="button" @click="getSuspension(x, 'CREATE')"
                                class="btn btn-sm btn-block btn-warning d-flex align-items-center justify-content-center">
                                <i class="mdi mdi-calendar-clock fs-6 me-1"></i>Show Contract Management
                              </button>
                              <span v-if="hasExtensionWithStatus(x, 'EXTENSION', 'PENDING') ||
                                hasExtensionWithStatus(x, 'SUSPENSION', 'PENDING')"
                                class="badge bg-danger rounded-pill position-relative"
                                style="bottom: 38px; left: 240px">!</span>
                            </div>
                            <div :class="{
                              'mt-3': !(hasExtensionWithStatus(x, 'EXTENSION', 'PENDING') ||
                                hasExtensionWithStatus(x, 'SUSPENSION', 'PENDING'))
                            }">
                              <b class="font-size-14 me-1">Attachments:</b>
                              <a href="javascript:void(0);" @click="getAttachments(x)"
                                :id="`pending-viewFiles-${x.id}`">[Show attachments]</a>
                              <b-popover :target="`pending-viewFiles-${x.id}`" triggers="click" placement="right"
                                :show.sync="x.viewFile" custom-class="popover-supplier">
                                <template v-slot:title>
                                  <div class="d-flex align-items-center justify-content-between">
                                    <small>Attachments</small>
                                    <span class="bx bx-x font-size-14 cursor-pointer"
                                      @click="x.viewFile = false"></span>
                                  </div>
                                </template>
                                <table class="table table-bordered" v-if="
                                  !x.attachmentLoading && x.poFiles.length > 0
                                ">
                                  <thead>
                                    <tr>
                                      <th>File Description</th>
                                      <th style="width: 30px"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="y in x.poFiles" :key="y.id">
                                      <td @click="openDocument(y)" class="hoverable-link cursor-pointer">
                                        <div>
                                          {{ y.description }}
                                        </div>
                                        <small>
                                          <div>
                                            Uploaded By {{ y.uploadedBy }}
                                          </div>
                                          <div>
                                            {{
                                              formatDateWithTime(
                                                new Date(y.dateTimeUploaded)
                                              )
                                            }}
                                          </div>
                                        </small>
                                      </td>
                                      <td>
                                        <i v-if="
                                          isAdmin ||
                                          y.applicationUserId ==
                                          token.ApplicationUserId
                                        " @click="removeFile(y.id, x.id)"
                                          class="cursor-pointer bx bx-trash text-danger"></i>
                                        <i v-else class="bx bx-trash text-muted"></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="text-center" v-if="
                                  !x.attachmentLoading &&
                                  x.poFiles.length == 0
                                ">
                                  No data found
                                </div>
                                <div v-if="x.attachmentLoading" class="text-center">
                                  <b-spinner variant="primary" label="Loading..."></b-spinner>
                                </div>
                              </b-popover>
                            </div>
                            <div v-if="!viewOnly" class="mt-2">
                              <button :id="`pending-document-${x.id}`" type="button"
                                class="btn btn-sm btn-outline-success" @click="x.addDocu = !x.addDocu">
                                <i class="bx bx-plus"></i>Add Attachments
                              </button>
                              <upload-popover :option="uploadOptions" :sourceId="x.id" @uploaded="uploadedFiles"
                                :showPV="x.addDocu" @closePopover="x.addDocu = false" :dzId="`pending-dropzone-${x.id}`"
                                :pvId="`pending-document-${x.id}`"></upload-popover>
                            </div>
                          </div>
                          <div class="border-start border-3 ps-2" style="width: 100%">
                            <div class="ms-2">
                              <div class="mb-2">
                                <div class="d-flex justify-content-between">
                                  <b class="mt-2 mb-1 font-size-16">Incoming Items:</b>
                                  <div class="d-flex align-items-center">
                                    <transition>
                                      <button v-if="
                                        selectedRowCheck(x.rfqSupplierOffers)
                                      " type="button" @click="createIar(x)"
                                        class="btn btn-sm btn-success mb-2 ms-2 d-flex align-items-center">
                                        <i class="mdi mdi-truck-outline fs-6 me-1"></i>
                                        Delivery
                                      </button>
                                    </transition>
                                  </div>
                                </div>
                              </div>
                              <div v-if="x.loading" class="p-3 border d-flex align-items-center justify-content-center">
                                <div class="preloader-component me-2">
                                  <div class="status">
                                    <div class="spinner-chase w-25px h-25px">
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                    </div>
                                  </div>
                                </div>
                                <h5 class="mb-0">Loading...</h5>
                              </div>
                              <div class="p-3 border d-flex align-items-center justify-content-center"
                                v-else-if="x.rfqSupplierOffers.length == 0">
                                <h5 class="text-muted">
                                  <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
                                </h5>
                              </div>
                              <div v-else>
                                <table width="100%">
                                  <thead>
                                    <tr>
                                      <th class="py-2" style="min-width: 400px">
                                        <div class="row m-0">
                                          <div class="col-6 p-0 pe-5">
                                            <b>Supplier Offer:</b>
                                          </div>
                                          <div class="col-6 p-0 pe-5">
                                            <b>Requested Item:</b>
                                          </div>
                                        </div>
                                      </th>
                                      <th class="py-2" style="width: 250px">
                                        Requisitioning Office/Dept.:
                                      </th>
                                      <th class="py-2" style="width: 150px">
                                        Unit Price
                                      </th>
                                      <th class="py-2" style="width: 150px">
                                        Items Remaining
                                      </th>
                                      <th class="py-2" style="width: 70px">
                                        Actions
                                      </th>
                                      <th v-if="!viewOnly" class="py-2" style="width: 30px">
                                        <div class="form-check form-checkbox-outline form-check-success mb-0">
                                          <input type="checkbox" :id="`checkbox-${x.id}`" checked="checked"
                                            class="form-check-input" @change="toggleAll(x)"
                                            v-model="x.toggleAll" /><label :for="`checkbox-${x.id}`"
                                            class="form-check-label">
                                            All
                                          </label>
                                        </div>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="y in x.rfqSupplierOffers" :key="y.id" class="border-top">
                                      <td class="py-2 align-top">
                                        <div class="row m-0">
                                          <div class="col-6 p-0 pe-5">
                                            <div>
                                              {{ y.itemName }}
                                            </div>
                                            <small>{{ y.description }}</small>
                                          </div>
                                          <div class="col-6 p-0 pe-5">
                                            <div>
                                              {{ y.apiResourceItemName }}
                                            </div>
                                            <small>{{
                                              y.apiResourceDescription
                                            }}</small>
                                          </div>
                                        </div>
                                      </td>
                                      <td class="py-2 align-top">
                                        <div>{{ x.endUser }}</div>
                                        <small>{{ x.deliveryUnit }}</small>
                                      </td>
                                      <td class="py-2 align-top text-warning">
                                        {{ formatCurrency(y.unitCost) }}
                                      </td>
                                      <td class="py-2 align-top text-info">
                                        {{ y.availableItemsForIar }} of
                                        {{ y.quantity }}
                                      </td>
                                      <td v-if="!viewOnly" style="min-width: 70px" class="py-1 align-top">
                                        <i title="Edit Item" @click="updatePoItem(x, y)"
                                          class="mdi mdi-pencil font-size-18 text-info cursor-pointer ms-3"></i>
                                      </td>
                                      <td v-if="!viewOnly" class="py-2 align-top">
                                        <div class="form-check form-checkbox-outline form-check-success mb-0">
                                          <input type="checkbox" :id="`apiID-${x.id}-${y.id}`" class="form-check-input"
                                            @change="checkToggle(x)" v-model="y.toggleSelected"
                                            :disabled="y.empty ? true : false" />
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
              <div class="row pt-3 pb-3">
                <div v-if="rows > 0" class="col">
                  Showing {{ (currentPage - 1) * perPage + 1 }} -
                  {{
                    rows > (currentPage - 1) * perPage + perPage
                      ? (currentPage - 1) * perPage + perPage
                      : rows
                  }}
                  of {{ rows }}
                </div>
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="paginate pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab @click="getDataByStatus('completed')">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-clock-time-four-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Completed</span>
        </template>
        <div v-if="tabIndex == 8">
          <div class="card border-4 border-top border-start-0 border-end-0 border-primary">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <h4 class="m-0 pt-3">P.O. List</h4>
                <div class="d-flex align-items-center">
                  <div id="tickets-table_filter" class="tableDatas_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search PO..."
                        class="form-control"></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="tableDatas_length">
                    <label class="d-inline-flex align-items-center">
                      <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptions">
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
              <div class="border p-3 d-flex align-items-center justify-content-center" v-if="loading">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
              <div class="text-center border p-3" v-else-if="paginated.length == 0">
                <div v-if="filter != ''">
                  <i class="fas fa-exclamation-triangle me-2"></i>There are no
                  POs matching your request
                </div>
                <div v-else>
                  <i class="fas fa-exclamation-triangle me-2"></i>No POs
                  available
                </div>
              </div>
              <div v-else class="border">
                <div class="text-muted" role="tablist" v-for="(x, index) in paginated" :key="x.id">
                  <b-card no-body class="mb-0 border shadow-none"
                    :style="`z-index: ${paginated.length - index + 1000}`">
                    <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                    <b-card-header header-tag="header" role="tab">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <div class="d-flex align-items-center" style="min-width: max-content">
                            <div class="text-white">PO# {{ x.poNumber }}</div>
                            <div class="ms-2">|</div>
                            <small class="ms-2">
                              {{ x.supplierName }}
                            </small>
                          </div>
                          <div class="text-white font-size-14">
                            {{ x.description }}
                          </div>
                          <small>
                            <a href="javascript: void(0);" class="text-success d-flex align-items-center"
                              @click="getIarItems(x)">
                              {{ x.visible ? "Hide" : "Show" }}
                              Details
                              <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                'rotate-90': x.visible
                              }"></i>
                            </a>
                          </small>
                        </div>
                        <div v-if="!viewOnly" class="float-end d-flex align-items-center">
                          <i class="bx bx-printer font-size-18 text-purple cursor-pointer ps-2 pe-2 ms-2"
                            :id="`incoming-print-popover-${x.id}`" tabindex="0"></i>
                          <b-popover :target="`incoming-print-popover-${x.id}`" triggers="click blur"
                            placement="leftbottom" variant="purple" custom-class="p-0">
                            <b-list-group class="w-100 fit">
                              <b-list-group-item button action class="d-flex align-items-center text-purple"
                                @click="printDP(x.id)">Print Deployment</b-list-group-item>
                            </b-list-group>
                          </b-popover>
                          <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2" :id="`incoming-popover-${x.id}`" v-if="!x.visible" 
                            tabindex="0"></i>
                          <b-popover :target="`incoming-popover-${x.id}`" triggers="click blur" placement="leftbottom" v-if="!x.visible" 
                            variant="secondary" custom-class="p-0">
                            <b-list-group class="w-100 fit">
                              <b-list-group-item button action
                                class="d-flex align-items-center text-warning" @click="getSuspension(x, 'IAR')"><i
                                  class="mdi mdi-calendar-clock font-size-18 me-1"></i>Show Contract
                                Management</b-list-group-item>
                              <!-- <b-list-group-item button action class="d-flex align-items-center text-info"
                                @click="transferCampus(x)"><i class="mdi mdi-transfer font-size-18 me-1"></i>Transfer
                                {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</b-list-group-item> -->
                            </b-list-group>
                          </b-popover>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse class="border-bottom border-5" :visible="x.visible" :accordion="`po-accordion-${x.id}`"
                      role="tabpanel">
                      <b-card-body
                        class="border border-3 border-bottom-0 border-start-0 border-end-0 custom-table-responsive">
                        <div class="d-flex">
                          <div class="me-3" style="min-width: 250px">
                            <div v-if="!viewOnly"> <button type="button" @click="getSuspension(x, 'IAR')"
                                class="btn btn-sm btn-block btn-warning d-flex align-items-center justify-content-center">
                                <i class="mdi mdi-calendar-clock fs-6 me-1"></i>Show Contract Management
                              </button>
                              <span v-if="hasExtensionWithStatus(x, 'EXTENSION', 'PENDING') ||
                                hasExtensionWithStatus(x, 'SUSPENSION', 'PENDING')"
                                class="badge bg-danger rounded-pill position-relative"
                                style="bottom: 38px; left: 240px">!</span>
                            </div>
                            <div :class="{
                              'mt-3': !(hasExtensionWithStatus(x, 'EXTENSION', 'PENDING') ||
                                hasExtensionWithStatus(x, 'SUSPENSION', 'PENDING'))
                            }">
                              <b class="font-size-14 me-1">Attachments:</b>
                              <a href="javascript:void(0);" @click="getAttachments(x)"
                                :id="`completed-viewFiles-${x.id}`">[Show attachments]</a>
                              <b-popover :target="`completed-viewFiles-${x.id}`" triggers="click" placement="right"
                                :show.sync="x.viewFile" custom-class="popover-supplier">
                                <template v-slot:title>
                                  <div class="d-flex align-items-center justify-content-between">
                                    <small>Attachments</small>
                                    <span class="bx bx-x font-size-14 cursor-pointer"
                                      @click="x.viewFile = false"></span>
                                  </div>
                                </template>
                                <table class="table table-bordered" v-if="
                                  !x.attachmentLoading && x.poFiles.length > 0
                                ">
                                  <thead>
                                    <tr>
                                      <th>File Description</th>
                                      <th style="width: 30px"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="y in x.poFiles" :key="y.id">
                                      <td @click="openDocument(y)" class="hoverable-link cursor-pointer">
                                        <div>
                                          {{ y.description }}
                                        </div>
                                        <small>
                                          <div>
                                            Uploaded By {{ y.uploadedBy }}
                                          </div>
                                          <div>
                                            {{
                                              formatDateWithTime(
                                                new Date(y.dateTimeUploaded)
                                              )
                                            }}
                                          </div>
                                        </small>
                                      </td>
                                      <td>
                                        <i v-if="
                                          isAdmin ||
                                          y.applicationUserId ==
                                          token.ApplicationUserId
                                        " @click="removeFile(y.id, x.id)"
                                          class="cursor-pointer bx bx-trash text-danger"></i>
                                        <i v-else class="bx bx-trash text-muted"></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="text-center" v-if="
                                  !x.attachmentLoading &&
                                  x.poFiles.length == 0
                                ">
                                  No data found
                                </div>
                                <div v-if="x.attachmentLoading" class="text-center">
                                  <b-spinner variant="primary" label="Loading..."></b-spinner>
                                </div>
                              </b-popover>
                            </div>
                            <div v-if="!viewOnly" class="mt-2">
                              <button :id="`completed-document-${x.id}`" type="button"
                                class="btn btn-sm btn-outline-success" @click="x.addDocu = !x.addDocu">
                                <i class="bx bx-plus"></i>Add Attachments
                              </button>
                              <upload-popover :option="uploadOptions" :sourceId="x.id" @uploaded="uploadedFiles"
                                :showPV="x.addDocu" @closePopover="x.addDocu = false"
                                :dzId="`completed-dropzone-${x.id}`"
                                :pvId="`completed-document-${x.id}`"></upload-popover>
                            </div>
                          </div>
                          <div class="border-start border-3 ps-2" style="width: 100%">
                            <div class="ms-2">
                              <div class="mb-2">
                                <b class="mt-2 mb-1 font-size-16">Incoming Items:</b>
                              </div>
                              <div v-if="x.loading" class="p-3 border d-flex align-items-center justify-content-center">
                                <div class="preloader-component me-2">
                                  <div class="status">
                                    <div class="spinner-chase w-25px h-25px">
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                      <div class="chase-dot"></div>
                                    </div>
                                  </div>
                                </div>
                                <h5 class="mb-0">Loading...</h5>
                              </div>
                              <div class="p-3 border d-flex align-items-center justify-content-center"
                                v-else-if="x.rfqSupplierOffers.length == 0">
                                <h5 class="text-muted">
                                  <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
                                </h5>
                              </div>
                              <div v-else>
                                <table width="100%">
                                  <thead>
                                    <tr>
                                      <th class="py-2">Item Name</th>
                                      <th class="py-2 text-center" style="width: 120px">
                                        Items Waived
                                      </th>
                                      <th class="py-2 text-center" style="width: 120px">
                                        Items Delivered
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="y in x.rfqSupplierOffers" :key="y.id" class="border-top">
                                      <td class="py-2 align-top">
                                        <div class="d-flex mb-1">
                                          <div class="badge" :class="!y.isDelivered
                                            ? 'bg-danger'
                                            : y.iarStatus == 'PENDING'
                                              ? 'bg-secondary'
                                              : y.isPropertyCreated
                                                ? 'bg-success'
                                                : 'bg-purple'
                                            ">
                                            <b class="font-size-10">{{
                                              !y.isDelivered
                                                ? "WAIVED"
                                                : y.iarStatus == "PENDING"
                                                  ? "DELIVERED"
                                                  : y.isPropertyCreated
                                                    ? "COMPLETED"
                                                    : "PROCESSING IAR"
                                            }}</b>
                                          </div>
                                          <a v-if="
                                            y.iarStatus == 'PENDING' &&
                                            y.isDelivered
                                          " class="ms-1 font-size-10" href="javascript: void(0);"
                                            @click="getIar(y)">[Show More]</a>
                                        </div>
                                        <div class="font-size-14 text-white">
                                          {{ y.itemName }}
                                        </div>
                                        <small>{{ y.description }}</small>
                                      </td>
                                      <td class="py-2 align-top text-center">
                                        <b v-if="!y.isDelivered" class="text-danger">{{ y.quantity }}</b>
                                      </td>
                                      <td class="py-2 align-top text-center">
                                        <b v-if="y.isDelivered" class="text-info">{{ y.quantity }}</b>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
              <div class="row pt-3 pb-3">
                <div v-if="rows > 0" class="col">
                  Showing {{ (currentPage - 1) * perPage + 1 }} -
                  {{
                    rows > (currentPage - 1) * perPage + perPage
                      ? (currentPage - 1) * perPage + perPage
                      : rows
                  }}
                  of {{ rows }}
                </div>
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="paginate pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <!-- Find PO -->
    <transition name="fade">
      <div @mouseenter="mouseOverSearch = true" @mouseleave="mouseOverSearch = false" class="position-fixed"
        style="bottom: 20px; left: 50px">
        <div title="Search PO" class="avatar-sm mx-auto cursor-pointer" @click="searchPo()">
          <span class="avatar-title rounded-circle bg-info">
            <i class="mdi mdi-magnify font-size-24" :class="{
              'bx-tada': mouseOverSearch == true
            }"></i>
          </span>
        </div>
      </div>
    </transition>
    <PoSearch ref="PoSearch"></PoSearch>
    <contract ref="contract"></contract>
    <IAR ref="iar" @deleteSuccesful="getCompleted()"></IAR>
    <Warehouse ref="warehouse" @dropData="dropWarehouse($event)"></Warehouse>
    <Campus ref="campus" @dropData="dropCampus($event)"></Campus>
    <unit ref="unit" @dropData="dropUnit($event)"></unit>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.hide-disable {
  opacity: 1 !important;
}

.p-0 .popover-body {
  padding: 0 !important;
}

.paginate {
  z-index: -1 !important;
}

.tooltip {
  opacity: 1 !important;
}

.my-actions {
  padding: 10px 10px 0 10px;
  font-size: 12px;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.left-gap {
  margin-left: auto;
}

.v-enter-active {
  animation: fade-in 0.3s;
}

.v-leave-active {
  animation: fade-in 0.3s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
